import { getWebappClassicWindow, Webapp$dt } from '@/types/classic';

export default function userSession(): Webapp$dt['objConfig'] {
  return (
    getWebappClassicWindow()?.$dt?.objConfig || ({} as Webapp$dt['objConfig'])
  );
}
